// extracted by mini-css-extract-plugin
export default {"hide":"hide__G6XVN","show":"show__Z66Nq","stellarAge":"stellarAge__XKe9V"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"hide\":\"hide__G6XVN\",\"show\":\"show__Z66Nq\",\"stellarAge\":\"stellarAge__XKe9V\"}";
        // 1787130557576
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  